import * as React from 'react';

import type { Automation } from '../../../MedicareProAPI/Entities/Automation/Automation';

export interface AutomationNavSingleProps {
  automation: Automation;
  selected: boolean;
  onClick: (automation: Automation) => void;
}

export const AutomationNavSingle = (props: AutomationNavSingleProps): React.JSX.Element => {
  const [automation, setAutomation] = React.useState<Automation>(props.automation);
  const [selected, setSelected] = React.useState<boolean>(props.selected);

  React.useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  React.useEffect(() => {
    setAutomation(props.automation);
  }, [props.automation]);

  const classList = ['small', 'card', 'p-2', 'mb-2', 'cp', 'card-tall', 'border', 'border-info'];
  const badgeClassList = [
    'badge',
    'small',
    'float-right',
    'font-weight-normal',
    'text-white',
    'ml-1',
  ];

  if (selected === true) {
    classList.push('bg-info');
    classList.push('text-white');
  }

  const dangerClassList = [...badgeClassList, 'bg-danger'];
  const successClassList = [...badgeClassList, 'bg-success'];
  const warningClassList = [...badgeClassList, 'bg-warning'];
  const neutralClassList = [...badgeClassList, 'bg-secondary'];

  const badges = [];

  if (automation.getIsShared()) {
    badges.push({ classList: warningClassList, message: 'Shared' });
  }

  if (automation.getId()) {
    if (automation.getParentAutomation() && automation.getParentAutomation().getIsDeleted()) {
      badges.push({ classList: dangerClassList, message: 'Deleted by Principle' });
    } else if (automation.getIsDeleted()) {
      badges.push({ classList: dangerClassList, message: 'Deleted' });
    } else if (
      automation.getParentAutomation() &&
      !automation.getParentAutomation().getIsActive()
    ) {
      badges.push({ classList: neutralClassList, message: 'Deactivated by Principle' });
    } else if (!automation.getIsActive()) {
      badges.push({ classList: neutralClassList, message: 'Inactive' });
    } else if (
      (automation.getParentAutomation() && automation.getParentAutomation().getIsActive()) ||
      automation.getIsActive()
    ) {
      badges.push({ classList: successClassList, message: 'Active' });
    }
  }

  return (
    <div className={classList.join(' ')} onClick={(e) => props.onClick(automation)}>
      <div>
        {badges &&
          badges.map((badge) => (
            <div key={badge.message} className={badge.classList.join(' ')}>
              {badge.message}
            </div>
          ))}

        <p>
          <strong>{automation.getName() || <em>New Automation</em>}</strong>
        </p>
        <p>
          {automation.getAutomationActions()
            ? automation.getAutomationActions().getTotalItems()
            : 0}{' '}
          actions
        </p>
      </div>
    </div>
  );
};
